<template>
  <div
    ref="root"
    data-test="ustextslider"
    class="glide us-text-slider"
    tabindex="0"
  >
    <div class="glide__track" data-glide-el="track">
      <div class="glide__slides">
        <div
          v-for="(text, i) in texts"
          :key="`text-${i}`"
          class="glide__slide us-text-slider__slide"
        >
          <p class="body--p1--medium">{{ text }}</p>
        </div>
      </div>
    </div>
    <div
      v-if="texts.length"
      data-glide-el="controls[nav]"
      class="us-text-slider__controls"
    >
      <button
        v-for="(text, idx) in texts"
        :key="idx"
        :class="[
          'us-text-slider__controls-dot',
          idx == glideIndex ? 'us-text-slider__controls-dot--active' : ''
        ]"
        :data-glide-dir="'=' + idx"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, onUnmounted, PropType, ref } from 'vue'

import USArrowButton from '../USArrowButton/USArrowButton.vue'

import Glide from '@glidejs/glide'
import { GlideKeyboard } from '@base/@motiv/fe-patterns'

export default defineComponent({
  name: 'USTextSlider',
  components: {
    USArrowButton
  },
  props: {
    texts: { type: Array as PropType<Array<string>>, default: () => [] }
  },
  setup() {
    let glide: Glide.Static | undefined
    let glideKeyboard: GlideKeyboard | undefined

    const root = ref<HTMLElement | null>(null)
    let glideIndex = ref<number>(0)

    onMounted(() => {
      if (!root.value) return
      glide = new Glide(root.value as any, {
        autoplay: 10000,
        type: 'carousel',
        rewind: false,
        keyboard: false,
        focusAt: 'center',
        perView: 1,
        gap: 20
      })

      glide.mount()
      glide.on(['mount.after', 'run'], function () {
        glideIndex.value = glide.index
      })

      glideKeyboard = new GlideKeyboard('.glide.us-text-slider', glide)
    })

    onUnmounted(() => {
      if (glide) glide.destroy()
      if (glideKeyboard?.destory()) glideKeyboard.destory()
    })

    return { root, glideIndex }
  }
})
</script>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/foundations/breakpoint' as bp;
// @import 'node_modules/@glidejs/glide/src/assets/sass/glide.core';

.us-text-slider {
  border-radius: var(--border-radius-1);
  background-color: var(--color-secondary-15);
  position: relative;
  overflow: hidden;

  &__controls {
    // align-items: center;
    height: 100%;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    padding: 0 var(--spacing--3) var(--spacing--7) var(--spacing--3);
    margin: 0 auto;
    max-width: bp.$breakpoint--desktop;
    // position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;

    button {
      pointer-events: all;
    }
  }

  &__controls-dot {
    background: var(--color--neutral-a5);
    border-radius: var(--border-radius--round);
    height: 10px;
    margin-left: calc(var(--spacing--8) / 2);
    margin-right: calc(var(--spacing--8) / 2);
    width: 10px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &--active {
      background: var(--color--secondary-c1);
    }
  }

  &__slide {
    align-items: center;
    color: var(--color--neutral-a1);
    display: flex;
    justify-content: center;
    height: auto;
    text-align: center;

    p {
      padding: var(--spacing--7) var(--spacing--3) var(--spacing--8)
        var(--spacing--3);
      margin: 0 auto;
      max-width: var(--breakpoint--9);
    }
  }
}
</style>
